import styled from 'styled-components';
import arrow from 'src/assets/images/user-mobile/parking/Arrow.svg';
import arrowOrange from 'src/assets/images/user-mobile/parking/Arrow-orange.svg';
import { useState } from 'react';
import {
  complexityList,
  parkingFestivalList,
} from 'src/assets/database/parkingData';
import AccessableApp from './modal/AccessableApp';
import { ParkingLot } from './ParkingList';
// navigate버튼들 필요

interface ParkingBoxProps {
  parkingList: ParkingLot[];
  festivalId: number;
}

export default function ParkingBox({
  parkingList,
  festivalId,
}: ParkingBoxProps) {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedParking, setSelectedParking] = useState<ParkingLot | null>(
    null,
  );

  const handleOpenModal = (place: ParkingLot) => {
    setSelectedParking(place);
    setIsOpen(true);
  };
  const festivalStyle = parkingFestivalList.find(
    f => f.festivlaId === festivalId,
  )?.data;

  return (
    <>
      <ParkingContainer>
        {parkingList.map(place => {
          const complexityData = complexityList.find(
            item => item.complexity === place.complexity,
          ) || { textcolor: '#505050' };

          return (
            <ParkBox key={place.name}>
              <TextArea>
                <Title>
                  {place.name}
                  <Badge textcolor={complexityData.textcolor}>
                    {place.complexity}
                  </Badge>
                </Title>
                <Distance>축제장까지 거리 {place.distance}</Distance>
              </TextArea>
              <NavigationLink
                onClick={() => handleOpenModal(place)}
                bgColor={festivalStyle?.navigatebutton}
                textColor={festivalStyle?.navigatebuttonText}
              >
                길찾기
                <img src={festivalId === 7 ? arrow : arrowOrange} alt="arrow" />
              </NavigationLink>
            </ParkBox>
          );
        })}
      </ParkingContainer>

      {isOpen && selectedParking && (
        <AccessableApp
          parking={selectedParking}
          onClose={() => setIsOpen(false)}
          festivalId={festivalId}
        />
      )}
    </>
  );
}

const ParkingContainer = styled.div`
  width: 100%;
  padding: 10px 20px 0 20px;
  background-color: #ffffff;
`;

const ParkBox = styled.div`
  justify-content: space-between;
  display: flex;
  align-items: center;
  width: 100%;
  border-bottom: 1px solid #f1f1f1;
`;

const TextArea = styled.div`
  margin-bottom: 15px;
`;

const Title = styled.div`
  margin-top: 14px;
  color: var(--Font-02_black, #111);
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px;
  display: flex;
  align-items: center;
  padding-bottom: 5px;
`;

const Badge = styled.span<{ textcolor: string }>`
  margin-left: 6px;
  padding: 2px 7px;
  border-radius: 15px;
  border: 1px solid ${({ textcolor }) => textcolor};
  color: ${({ textcolor }) => textcolor};
  font-size: 13px;
  font-weight: 600;
  line-height: 20px;
`;

const Distance = styled.div`
  color: #303030;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
`;

const NavigationLink = styled.button<{
  bgColor?: string;
  textColor?: string;
}>`
  font-size: 15px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 11px 16px;
  gap: 4px;
  border-radius: 12px;
  background: ${({ bgColor }) => bgColor || '#f2f2f5'};
  color: ${({ textColor }) => textColor || '#111'};
`;
